<template>
    <sub-page id="offlineRecordDetail" :fullPage="true">
            <div class="user-container">
                <ui-panel class="user-panel" :title="$t('train.trainees')" icon="inuc-members">
                    <div class="search-box">
                        <div class="search-box-inner">
                            <el-input v-model="username" @input="searchChange" :placeholder="$t('tip.usernameOrAccount')"
                                      clearable>
                                <el-button slot="prepend" icon="el-icon-search"></el-button>
                            </el-input>

                        </div>
                    </div>
                    <data-tables class="form-table"
                                     ref="trainTable"
                                     :data="userList"
                                     :table-props="tableProps"
                                     :page-size="20"
                                     :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                        >

                            <!-- column title -->
                            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                             :key="title.label"
                                             align="center"
                                             sortable="custom">
                            </el-table-column>

                            <el-table-column :label="$t('c.status')" property="statusName" align="center"
                                             sortable="custom" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span class="plan-status" :class="getStatus(scope.row.status)">{{scope.row.statusName}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column :label="$t('c.operation')" align="center" v-if="userInfo.userID==creator">
                                <div class="btn-cell" slot-scope="scope">
                                    <i class="nucfont inuc-edit" v-if="scope.row.status!=4"
                                       @click="editUser(scope.row.userID)"></i>
                                </div>
                            </el-table-column>
                        </data-tables>
                </ui-panel>
            </div>

        <!-- 请假 -->
        <el-dialog
            :title="$t('c.edit')"
            :visible.sync="editDialog"
            custom-class="edit-dialog"
            width="600px"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
        >
            <el-form
                :model="editForm"
                ref="editForm"
                :rules="editRules"
                label-width="100px">
                <el-form-item :label="$t('train.reason')+'：'" prop="reason">
                    <el-radio-group v-model="editForm.reason">
                        <el-radio-button :label="$t('train.casualLeave')"></el-radio-button>
                        <el-radio-button :label="$t('train.sickLeave')"></el-radio-button>
                        <el-radio-button :label="$t('train.annualLeave')"></el-radio-button>
                        <p style="margin-top:10px;"></p>
                        <el-radio-button :label="$t('train.parentalLeave')"
                                         style="border-left:1px solid #dcdfe6;"></el-radio-button>
                        <el-radio-button :label="$t('train.maternityLeave')"></el-radio-button>
                        <el-radio-button :label="$t('train.paternityLeave')"></el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('c.desc')+'：'" prop="remark">
                    <el-input type="textarea" v-model="editForm.remark"
                              :autosize="{ minRows: 3, maxRows: 4}"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="saveEditForm" :loading="editLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>

    </sub-page>
</template>

<script>
    import SubPage from '@/components/Subpage.vue';
    import uiPanel from '@/components/UIPanel.vue';
    import api from '@/api';
    import {Ticket} from '@/utils';

    export default {
        props: ['planId', 'creator'],
        data() {
            return {
                isShow: false,
                username: '',
                userList: [],
                editDialog: false,
                editForm: {
                    reason: '',
                    remark: '',
                },
                editRules: {
                    reason: [
                        {required: true, message: this.$t('tip.reason'), trigger: 'blur'},
                    ],
                },
                editLoading: false,

                paperShow: false,
                paperInfo: {},
                topicData: [],
                userInfo: {},
                filterData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                titles: [
                    {
                        prop: 'userName',
                        label: this.$t('c.username')
                    }, {
                        prop: 'accountNo',
                        label: this.$t('c.account')
                    }, {
                        prop: 'orgName',
                        label: this.$t('c.organizations')
                    }, {
                        prop: 'postName',
                        label: this.$t('c.position')
                    }, {
                        prop: 'gradeName',
                        label: this.$t('c.grade')
                    },
                    {
                        prop: 'checkInTime',
                        label: this.$t('train.checkInTime')
                    }
                ],

            }
        },
        mounted() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }
            this.getUsers();
        },
        computed: {
        },
        methods: {
            getUsers() {
                api.getOfflineUsers(this.planId).then(res => {
                    let data = res.package;
                    if (!data.length) return;
                    data.forEach(item => {
                        item.checkInTime = item.checkInTime ?  item.checkInTime:'-';
                        item.postName = item.postName ? item.postName : '';
                        item.gradeName = item.gradeName ? item.gradeName : '';
                    });
                    this.allUsers = data;
                    this.userList = data;

                });
            },
            editUser(userID) {
                this.editDialog = true;
                this.$refs['editForm'] && this.$refs['editForm'].resetFields();
                this.currentUserID = userID;
            },
            saveEditForm() {
                this.$refs['editForm'].validate((valid) => {
                    if (!valid) return;

                    this.editLoading = true;
                    api.reviseOffline(this.planId, {
                        userID: this.currentUserID,
                        ...this.editForm
                    }).then(res => {
                        this.editDialog = false;
                        this.editLoading = false;

                        this.$message({
                            message: this.$t('m.editSuccess'),
                            type: 'success'
                        });
                        this.getUsers();
//                        let currentUser = this.allUsers.find(v => v.userID == this.currentUserID);
//                        currentUser.status = 3;
//                        currentUser.statusName = this.$t('train.passiveFinish');
//                        currentUser.percent = 1;
//                        this.searchChange(this.username);
                    }).catch(error => this.editLoading = false);

                });
            },


            searchChange(val) {
                val = $.trim(val);

                if (val === '') {
                    this.userList = [...this.allUsers];
                    return
                }

                let rst = [];
                this.allUsers.forEach(item => {
                    if (item.accountNo.indexOf(val) > -1 ||
                        item.userName.indexOf(val) > -1 ) {
                        rst.push(item)
                    }
                });
                this.userList = [...rst];
            },
            topicTypeBg(type, status) {
                let bgColor = '';
                switch (status){
                    case 0: //已报名
                        bgColor = 'blue';
                        break;
                    case 1://正常
                        bgColor = 'green';
                        break;
                    case 2://迟到
                        bgColor = 'yellow';
                        break;
                    case 3://异常
                        bgColor = 'red';
                        break;
                    case 4://缺席
                        bgColor = 'gray';
                        break;
                    default:
                        bgColor = 'blue';
                        break;
                }
                return bgColor;
            },
            getStatus(status) {
                return [
                    'registered',   //0 已报名
                    'normal',       //1 正常
                    'late',         //2 迟到
                    'error',        //3 异常
                    'absence',      //4 缺席
                ][status]
            },
        },
        watch: {
        },
        components: {
            SubPage,
            uiPanel,
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .user-container {
        height: 100%;
    }

    .record-container {
        flex: 1;
        margin-left: 20px;
    }

    .user-panel {
        height: 100%;
        display: flex;
        flex: 1;
        flex-direction: column;

        /deep/.panel-body {
            display: flex;
            flex: 1;
            flex-direction: column;
        }

        .search-box {
            width: 300px;
            margin-bottom: 20px;

            .search-box-inner {
                display: flex;
            }

            .el-input {
                flex: 1;
                margin-right: 10px;
            }
        }
        .form-table {
            display: flex;
            flex: 1;
            flex-direction: column;
        }
    }
    .plan-status {
        display: inline-block;
        color: #fff;
        min-width: 84px;
        border-radius: 2px;
        font-size: 14px;
        text-align: center;

        &.status {
            background-color: #23b7e5;
        }
        &.registered {
            background-color: #2e7faa;
        }
        &.normal {
            background-color: #FFB822;
        }
        &.late {
            background-color: #0396a6;
        }
        &.error {
            background-color: #c47a76;
        }
        &.absence {
            background-color: #8c7b6c;
        }
    }

</style>
